import { useContext } from "react";
import { AuthTokenContext } from "./AuthTokenContext";

/**
 * Hook to retrieve the authentication token from the AuthTokenProvider context.
 *
 * @returns The current authentication token, or null if not provided.
 *
 * @example
 * ```tsx
 * const authToken = useAuthTokenContext();
 * // Use authToken for API requests
 * ```
 */
export function useAuthTokenContext(): string | null {
  const { authToken } = useContext(AuthTokenContext);
  return authToken;
}
